import { InspectionTemplateStatus } from './templateStatus';
import { GeneralNormConfig } from './generalNormConfig';
import { InspectionTemplateInDto } from 'shared/dtos/in/template';
import { InspectionTemplateOutDto } from 'shared/dtos/out/template';

export type TemplateWizardSubmitResult = Pick<InspectionTemplateInDto, '_id'>;

export interface TemplateWizardTemplateInput {
  process: string;
  summary: string;
  generalNorm: string;
  generalNormConfig: GeneralNormConfig;
}

export interface TemplateWizardSectionInput {
  _id?: string;
  title: string;
  description: string;
}

export function toTemplateWizardDraftPayload(
  template: TemplateWizardTemplateInput
): InspectionTemplateOutDto {
  return {
    process: template.process,
    summary: template.summary,
    status: InspectionTemplateStatus.draft,
    generalNorm: {
      description: template.generalNorm,
    },
    generalNormConfig: template.generalNormConfig,
  };
}

export function buildPreviousSectionsById<T extends { _id?: string }>(
  sections: readonly T[]
): Map<string, T> {
  return new Map(
    sections
      .filter((section) => Boolean(section._id))
      .map((section) => [section._id!, section])
  );
}

export function buildSectionsToUpdate<T extends TemplateWizardSectionInput>(
  sections: readonly T[],
  previousSectionsById: ReadonlyMap<string, T>
): T[] {
  return sections.filter((section) => {
    if (!section._id) {
      return false;
    }

    const previousSection = previousSectionsById.get(section._id);
    if (!previousSection) {
      return false;
    }

    return (
      previousSection.title !== section.title ||
      previousSection.description !== section.description
    );
  });
}